import type { FC } from 'react';
import { Box, Checkbox as MuiCheckbox, Typography } from '@mui/material';
import ColumnVisibilityMenu from './ColumnVisibilityMenu';
import GroupByHypothesisToggle from './GroupByHypothesisToggle';
import type { CreativeColumnKey } from '../../types/hypothesis';

interface TestCreativesHeaderProps {
  totalCreatives: number;
  hypothesisCount: number;
  groupByHypothesis: boolean;
  onGroupByHypothesisChange: (val: boolean) => void;
  allSelected: boolean;
  someSelected: boolean;
  onToggleSelectAll: () => void;
  columnOrder: CreativeColumnKey[];
  visibilityModel: Record<string, boolean>;
  onToggleColumn: (key: CreativeColumnKey) => void;
  onMoveColumn: (key: CreativeColumnKey, direction: 'up' | 'down') => void;
  onResetColumns: () => void;
}

const TestCreativesHeader: FC<TestCreativesHeaderProps> = ({
  totalCreatives,
  hypothesisCount,
  groupByHypothesis,
  onGroupByHypothesisChange,
  allSelected,
  someSelected,
  onToggleSelectAll,
  columnOrder,
  visibilityModel,
  onToggleColumn,
  onMoveColumn,
  onResetColumns,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <MuiCheckbox
          size="small"
          checked={allSelected}
          indeterminate={someSelected}
          onChange={onToggleSelectAll}
        />
        <Typography variant="body1" fontWeight={500}>
          {groupByHypothesis
            ? `${hypothesisCount} Hypothesis`
            : `${totalCreatives} Creative${totalCreatives !== 1 ? 's' : ''}`}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GroupByHypothesisToggle
          checked={groupByHypothesis}
          onChange={onGroupByHypothesisChange}
        />
        <ColumnVisibilityMenu
          columnOrder={columnOrder}
          visibilityModel={visibilityModel}
          onToggle={onToggleColumn}
          onMove={onMoveColumn}
          onReset={onResetColumns}
        />
      </Box>
    </Box>
  );
};

export default TestCreativesHeader;
